import core from '@/admin/core';
import myAttributes from '@/composition/myAttributes';

export interface EventLottery  {
  id: string;
  title: string;
  thumbnail: string;
  description: string;
  descriptionImages: string[];
  deliveryDescription: string;
  deliveryDescriptionImages: string[];
  annotation: string;
  annotationImages: string[];
  purchaseAuthority: object;
  price: number;
  isRequiredShippingAddress: boolean;
  isRequiredShippingFee: boolean;
  shippingFee: number;
  additionalShippingFeeCount: number;
  prizeRankType: string[];
  enable10Draws: boolean;
  enable10DrawsGiftPrize: boolean;
  enableLosePrize: boolean;
  showOutOfStockLabel: boolean;
  accessStartDate?: number;
  accessEndDate?: number;
  purchaseStartDate?: number;
  purchaseEndDate?: number;
  deliveryStartDate?: number;
  deliveryEndDate?: number;
  isUnderMaintenance: boolean;
  maintenanceDescription?: string;
  plannedSalesQuantity?: number;
  salesQuantity?: number;
  lotteryStatus: string[];
  periodStatus: string[];
  eventPrizes: object[];
  isDeleted: boolean;
  deleteDate?: number;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const getEventLotteries = async () => {
  if (myAttributes.myRequestPermissions?.eventLotteries) {
    try {
      const result = await core.httpClient.get('/v2/eventLottery/public/queries/getEventLotteryList');
      return result.data as EventLottery[];
    } catch (e) {
      return [];
    }
  } else return [];
};